import { type RouteRecordRaw } from 'vue-router'
import {ROUTES} from '@myorg/type-lib'
import {TermsOfService} from '@myorg/account-lib'

export const termsOfServiceRoute: RouteRecordRaw = {
    path: ROUTES.TERMS_SERVICE.PATH,
    name: ROUTES.TERMS_SERVICE.NAME,
    component: TermsOfService,
}